const cancelDialog = {
	alert:
		"Let op! Deze actie kan tot <strong>{{date}}</strong> teruggedraaid worden. Op <strong>{{date}}</strong> wordt de PBS datastore definitief verwijderd.",
	description:
		"Wanneer u deze dienst opzegt zal deze op <strong>({{date}})</strong> worden beëindigt en wordt de data definitief verwijderd. Ter bevestiging vragen we u om de naam van de PBS (<strong>{{name}}</strong>) hieronder te herhalen. ",
	input: {
		label: "Naam PBS",
		placeholder: "Herhaal PBS naam",
	},
	messages: {
		success:
			"Uw aanvraag om PBS <strong>{{name}}</strong> op te zeggen is succesvol ontvangen. Uw PBS zal per <strong>{{date}}</strong> opgezegd en opgeruimd worden.",
	},
	submit_button: "PBS opzeggen",
	title: "PBS opzeggen",
};

const cancellationPending = {
	button: "Opzegging annuleren",
	description:
		"Let op! Deze PBS dienst is opgezegd en zal per <strong>{{date}}</strong> niet meer beschikbaar zijn. U kunt deze actie nu nog annuleren.",
	dialog: {
		description:
			"Weet u zeker dat u de PBS opzegging voor <strong>{{name}}</strong> ongedaan wilt maken? De dienst zal weer gefactureerd gaan worden.",
		messages: {
			success:
				"De opzegging voor PBS <strong>{{name}}</strong> is succesvol geannuleerd. De dienst blijft actief.",
		},
		title: "Deze PBS opzegging annuleren",
	},
};

const edit = {
	status_messages: {
		success: "Uw PBS is succesvol bijgewerkt!",
	},
	title: "PBS beheren - {{name}}",
};

const editSync = {
	no_sync_job:
		"Geen synchronisatietaak gevonden voor PBS <strong>{{name}}</strong>. Zorg ervoor dat deze PBS een actieve synchronisatietaak heeft ingesteld.",
	title: "PBS sync beheer - {{name}}",
};

const overview = {
	bttn_create: "Tuxis PBS aanmaken",
	card: {
		body: {
			free_version: "Gratis versie",
			hostname: "PBS hostnaam",
			in_use: "In gebruik",
			location: "Serverlocatie",
			name: "Datastore naam",
			new: "Recent aangemaakt",
			username: "PBS gebruiker",
		},
		footer: {
			bttn: "Toon details",
		},
		progress: {
			auto_expand: {
				chart_icon: "Wanneer uw datastore deze grens bereikt, wordt deze automatisch vergroot.",
				notification:
					"U ontvangt een notificatie per e-mail wanneer de datastore de grens van <strong>{{value}}</strong> heeft bereikt.",
			},
			limited_size: {
				data_usage: "{{current}} van {{total}}",
				notification:
					"U ontvangt een notificatie per e-mail wanneer er nog <strong>{{value}}</strong> aan opslagruimte over is in de datastore.",
			},
			no_usage_alert:
				"Op dit kan het datastore verbruik niet opgehaald worden. Probeer het later nogmaals",
			title: "Datastore gebruik",
		},
	},
	empty: "U hebt nog geen Tuxis PBS account",
	title: "Tuxis PBS overzicht",
};

const page = {
	alert_tile: {
		alert_email_address: "Notificatie-adres",
		alert_pruning: {
			disabled: "Nee",
			enabled: "Ja",
			label: "Notificeer bij pruning fouten",
		},
		alert_threshold: {
			disabled: "Nooit",
			enabled_auto_expand: "er meer dan <strong>{{value}}</strong> in gebruik is",
			enabled_limited_size: "er minder dan <strong>{{value}}</strong> ruimte vrij is.",
			label: "Notificeer indien",
		},
		title: "Notificaties",
	},
	current_usage: {
		in_use: "Momenteel in gebruik",
		quota_limited_size: "Maximale capaciteit datastore",
		title: "Actueel verbruik",
	},

	data_usage: {
		title: "Opslaggebruik",
	},
	delete_button: "PBS opzeggen",
	edit_button: "PBS bewerken",

	info_tile: {
		description: "Omschrijving",
		host: "PBS Hostnaam",
		location: "Serverlocatie",
		name: "Datastore Naam",

		product_config: {
			auto_expand: "Grow as you go",
			free_version: "Datastore vast limiet - Gratis",
			limited_size: "Datastore vast limiet",
			title: "Opslag Instelling",
		},
		product_variant: {
			free: "Tuxis PBS Gratis - 150 GB",
			paid: "Tuxis PBS per 1TB",
			sync_job: "Synced Datastore uitvoering",
			title: "Datastore Uitvoering",
		},
		relation_title: "Gekoppelde Relatie",
		title: "PBS Informatie",
		username: "PBS Gebruiker",
	},
	password_tile: {
		credentials_saved_button: "Ik heb de gegevens opgeslagen",
		description:
			"De inloggegevens staan <strong>30 dagen</strong> in de wachtwoordkluis. Sla deze gegevens op in uw eigen wachtwoordmanager. Wanneer u inlogt op de webportal van PBS, kies de realm <strong>@pbs - Proxmox Backup authentication server</strong>.\nGebruik voor het koppelen van uw Proxmox VE-server(s) de API-key die wij voor u aangemaakt hebben.",
		description_completed:
			"De inloggegevens uit de wachtwoordkluis hebt u opgeslagen in uw wachtwoordmanager. Wanneer u inlogt op de webportal van PBS, kies de realm <strong>@pbs - Proxmox Backup authentication server</strong>.\nGebruik voor het koppelen van uw Proxmox VE-server(s) de API-key die wij voor u aangemaakt hebben.",
		password_vault_button: "Naar wachtwoordkluis",
		title: "PBS inloggegevens",
	},
	sync_job: {
		link_pbs_external: "Sync job bekijken",
		pbs_source_id: "Geselecteerde Tuxis PBS",
		remote_auth_id: "Auth-ID",
		remote_datastore: "Remote datastore",
		remote_host: "Remote host",
		schedule: "Synchronisatie interval",
		source_pbs_variant: "Source PBS variant",
		ssl_fingerprint: "SSL-fingerprint",
		sync_status: "Sync status",
		title: "Sync job",
	},
	sync_job_dialog_delete: {
		description:
			"Weet u zeker dat u de sync job wil verwijderen voor PBS <strong>{{datastore_name}}</strong>?",
		success: "De sync-job voor <strong>{{datastore_name}}</strong> is succesvol verwijderd!",
		title: "Sync job verwijderen?",
		warning:
			"Let op! Wanneer u een sync-job verwijderd kan deze niet opnieuw aangemaakt worden voor deze PBS. De PBS dienst blijft bestaan. Deze dient u apart op te zeggen.",
	},
};

const table = {
	body: {
		is_free_version: "- Gratis",
	},
	cancellation_pending: "Opgezegd",
	created_at: "Aangemaakt op",
	details: "Details",
	header: {
		cancellation_pending: "Opgezegd",
		created_at: "Aangemaakt op",
		datastore_config: "Configuratie",
		datastore_name: "Datastore naam",
		host: "Hostnaam",
		id: "PBS id",
		location: "Server locatie",
	},
	host: "Hostnaam",
	id: "PBS id",
	location: "Server locatie",
	name: "Datastore naam",
	order_code: "Order Nr.",
	relation: "Gekoppelde relatie",
	type: "Configuratie",
	username: "Gebruikers naam",
};

const manage = {
	cancel_dialog: cancelDialog,
	cancellation_pending: cancellationPending,
	edit: edit,
	edit_sync: editSync,
	overview: overview,
	page: page,
	table: table,
};

export default manage;
